import React from "react";
import { Link } from "react-router-dom";
import { policyGroups } from "../Datas/policyData";
import "../css/privacy.scss";

function Policies() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="privacy policy-hub">
      <div className="min-h-80vh px-4 lg-px-27px 2xl-px-89px">
        <div className="min-h-45px ml-full-width w-screen bg-f7f7f7 hidden md-block">
          <div className="breadcrumbs">
            <Link onClick={toTop} to="/">Home</Link>
            <span className="px-2">/</span>
            <span>Policies & Legal</span>
          </div>
        </div>

        <main className="policy-hub-inner">
          <header className="policy-hub-header">
            <p className="policy-eyebrow">FAILBLOSSOM CUSTOMER INFORMATION</p>
            <h1>Policies & Legal</h1>
            <p>Clear information about orders, privacy, website use, product standards and responsible business.</p>
          </header>

          <div className="policy-groups">
            {policyGroups.map((group) => (
              <section className="policy-group" key={group.title}>
                <h2>{group.title}</h2>
                <p>{group.description}</p>
                <ul>
                  {group.items.map(([label, to]) => (
                    <li key={to}>
                      <Link to={to} onClick={toTop}>
                        <span>{label}</span>
                        <span aria-hidden="true">→</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>

          <aside className="policy-contact">
            <h2>Need help?</h2>
            <p>Email <a href="mailto:level@failblossom.lifestyle">level@failblossom.lifestyle</a>. Include your order number if your question relates to a purchase.</p>
          </aside>
        </main>
      </div>
    </div>
  );
}

export default Policies;
